import history from './history.json';

export default { ...history };
